import React from 'react';
import { useFela, } from 'react-fela';
import PropTypes from 'prop-types';
import { parseStyleProps, } from '@haaretz/htz-css-tools';
import HtzLink from '../HtzLink/HtzLink';
import { stylesPropType, } from '../../propTypes/stylesPropType';
import { attrsPropType, } from '../../propTypes/attrsPropType';

BlockLink.propTypes = {
  /**
   * An object of attrbutes to set on the DOM element.
   * Passed to the underlying react element
   */
  attrs: attrsPropType,
  /**
   * Nodes rendered inside `BlockLink`.
   * Passed to the underlying react element
   */
  children: PropTypes.node,
  /**
   * A url to be assigned to the DOM element, converts the button to an `'<a>'`
   * DOM element inside a Wrapped Next JS `<HtzLink />`
   */
  href: PropTypes.string.isRequired,
  /** Basic HTML target (destination window) */
  target: PropTypes.string,
  /** An onClick function */
  onClick: PropTypes.func,
  /** The HTML tag to render the `<BlockLink />` as */
  tagName: PropTypes.string,
  /** If true, disables the block link */
  disableBlockLink: PropTypes.bool,
  /**
   * A special property holding miscellaneous CSS values that
   * trump all default values. Processed by
   * [`parseStyleProps`](https://Haaretz.github.io/htz-frontend/htz-css-tools#parsestyleprops)
   */
  miscStyles: stylesPropType,
};

BlockLink.defaultProps = {
  attrs: null,
  children: null,
  onClick: null,
  tagName: 'article',
  miscStyles: null,
  target: null,
  disableBlockLink: false,
};

const blockLinkStyle = ({ theme, miscStyles, }) => ({
  position: 'relative',

  extend: [
    // Trump all other styles with those defined in `miscStyles`
    ...(miscStyles ? parseStyleProps(miscStyles, theme.mq, theme.type) : []),
  ],
});

// eslint-disable-next-line react/prop-types
export function BlockLinkInner({ href, target, onClick, }) {
  const { css, } = useFela();

  return (
    <HtzLink
      className={css({
        backgroundColor: 'transparent',
        bottom: '0',
        left: '0',
        position: 'absolute',
        right: '0',
        top: '0',
        zIndex: '0',
      })}
      href={href}
      onClick={onClick}
      target={target}
      attrs={{
        tabIndex: '-1',
        'aria-hidden': true,
      }}
    />
  );
}

export default function BlockLink({ attrs, children, href, onClick, tagName, target, disableBlockLink, miscStyles, }) {
  const { css, } = useFela({ miscStyles, });
  const BlockLinkWrapper = tagName;

  return (
    <BlockLinkWrapper className={css(blockLinkStyle)} {...attrs}>
      {children}
      { disableBlockLink
        ? null
        : <BlockLinkInner href={href} target={target} onClick={onClick} />}
    </BlockLinkWrapper>
  );
}
